import { render, staticRenderFns } from "./scoreAudit.vue?vue&type=template&id=47320f44&scoped=true"
import script from "./scoreAudit.vue?vue&type=script&lang=js"
export * from "./scoreAudit.vue?vue&type=script&lang=js"
import style0 from "./scoreAudit.vue?vue&type=style&index=0&id=47320f44&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47320f44",
  null
  
)

export default component.exports